import React from 'react';

const mobileBreakpoint = 768;
const smBreakpoint = 640;

export function useMediaQuery(query: string) {
  const [value, setValue] = React.useState(false);

  React.useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }

    const result = matchMedia(query);
    result.addEventListener('change', onChange);
    setValue(result.matches);

    return () => result.removeEventListener('change', onChange);
  }, [query]);

  return value;
}

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${mobileBreakpoint}px)`);
}

export function useIsSm() {
  return useMediaQuery(`(max-width: ${smBreakpoint}px)`);
}
